import { get, isEmpty } from "lodash-es";
import Vue from "vue";

export default Vue.extend<any, any, any, any>({
  data() {
    return {
      snackOpen: false,
      snackColor: "black",
      snackMessage: "",
      snackClass: "",
      snackStyle: "",
    };
  },

  computed: {
    snackBarData() {
      return this.$store.getters["app/getSnackbar"];
    },

    isMobile() {
      return this.$ui.isMobileView();
    },
  },

  watch: {
    snackBarData(newSnackBarData, oldSnackBarData) {
      const data = newSnackBarData;

      // flag - not launch snackbar if it's jwt expired error
      const isJWTExpired =
        get(data, "message", null) !== null
          ? get(data, "message", "").includes("jwt expired")
          : false;
      // flag - not launch snackbar if error is caused by moving route too fast
      const isMovingTooFast =
        this.$store.getters["app/getPageLoadingFirstTime"] === true &&
        this.$store.getters["app/getRouteOnChanged"] === true;
      // flag - if old === doNotClose and new !=== doNotClose --> launch old message
      const isOverrideDoNotClose =
        oldSnackBarData.doNotClose && !newSnackBarData.doNotClose;

      if (!isEmpty(data) && !isJWTExpired && !isMovingTooFast) {
        // close snackbar
        if (get(data, "isTriggerClose") === true) {
          this.snackOpen = false;
        } else {
          // reset classSnack
          this.snackClass = "";

          // open snackbar
          this.snackOpen = true;

          // message assignment
          this.snackMessage = data.message;
          this.snackStyle = data.style || "";

          if (!data.message) {
            if ((data.color || "").includes("error")) {
              this.snackMessage = "Error";
            }

            if ((data.color || "").includes("success")) {
              this.snackMessage = "Done";
            }
          }

          if (isOverrideDoNotClose) {
            this.$store.dispatch("app/toggleSnackBar", oldSnackBarData);
          }

          // set color
          // set snackbar with colored text (not white text)
          if (get(data, "color", "").includes("invert-")) {
            this.snackColor = null;
            this.snackClass = data.color;
          } else {
            this.snackColor = data.color || "black";
            // emptying class
            this.snackClass = "";
          }

          // add .no-sidebar-toolbar
          // if isNoSidebarToolbar
          if (get(data, "isNoSidebarToolbar")) {
            this.snackClass = `${this.snackClass} no-sidebar-toolbar`;
          }

          // add .closable
          // if isClose (snack can be closed by user)
          if (get(data, "isClose")) {
            this.snackClass = `${this.snackClass} closeable`;
          }
        }
      }
    },

    snack(newSnack) {
      // if snack is closed, reset vuex
      if (!newSnack) {
        // reset snackbar data in vuex
        this.$store.commit("app/mutationSnackBar", {});
      }
    },
  },
});
